(function () {
  var SECTION_ID = 'header';
  var CART_ADD_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/') + 'cart/add.js';
  var CART_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/') + 'cart';

  var CONTAINER_CANDIDATES = ['#CartDrawer', '#cart-drawer', '#cart-notification', '.cart-drawer', '[data-cart-drawer]'];

  var AUTOPLAY_INTERVAL_MS = 3000;
  var MANUAL_PAUSE_MS = 4000;
  var lastManualInteraction = 0;

  function findInDoc(doc) {
    for (var i = 0; i < CONTAINER_CANDIDATES.length; i++) {
      var el = doc.querySelector(CONTAINER_CANDIDATES[i]);
      if (el) return el;
    }
    return null;
  }

  function cardWidth(track) {
    var card = track.querySelector('.cart-upsell__card');
    if (!card) return 170;
    var style = getComputedStyle(track);
    var gap = parseInt(style.columnGap || style.gap || '10', 10) || 10;
    return card.getBoundingClientRect().width + gap;
  }

  function updateCartCountBubble() {
    fetch(CART_URL + '.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count-bubble, #cart-icon-bubble').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  // Vynutene pouzitie stylov priamo na elementy cez JS - obchadza WebKit bug,
  // kedy sa CSS nespravne aplikuje na prvu kartu po vlozeni cez innerHTML.
  function forceUpsellCardStyles() {
    var isMobile = window.innerWidth <= 480;
    document.querySelectorAll('.cart-upsell__card').forEach(function (card) {
      if (isMobile) {
        card.style.height = '84px';
        card.style.maxHeight = '84px';
        card.style.overflow = 'hidden';
        card.style.flexDirection = 'row';
        card.style.alignItems = 'center';
        card.style.width = '100%';
      } else {
        card.style.height = '';
        card.style.maxHeight = '';
        card.style.overflow = '';
        card.style.flexDirection = '';
        card.style.alignItems = '';
        card.style.width = '';
      }
      var form = card.querySelector('.cart-upsell__form');
      if (form && isMobile) {
        form.style.display = 'grid';
        form.style.gridTemplateColumns = 'minmax(0, 68px) minmax(0, 1fr)';
        form.style.alignItems = 'center';
        form.style.width = '100%';
      } else if (form) {
        form.style.display = '';
        form.style.gridTemplateColumns = '';
        form.style.width = '';
      }
    });
  }

  function refreshCartDrawer() {
    return fetch(CART_URL + '?section_id=' + SECTION_ID, { cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('Sekce ' + SECTION_ID + ' nenalezena');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // DÔLEŽITÉ: aktualizujeme LEN upsell blok (podľa ID CartDrawerUpsell),
        // nie celý #CartDrawer. Prepisovanie celého drawera ničilo
        // #CartDrawerForm / [data-products], na ktoré si theme.CartForm
        // drží internú JS referenciu -> položky sa potom vykresľovali
        // do odpojeného (detached) DOM elementu a v UI zmizli.
        var newUpsell = doc.getElementById('CartDrawerUpsell');
        var currentUpsell = document.getElementById('CartDrawerUpsell');
        if (newUpsell && currentUpsell) {
          currentUpsell.innerHTML = newUpsell.innerHTML;
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        forceUpsellCardStyles();
      })
      .catch(function (err) {
        console.warn('[cart-drawer-upsell] refresh selhal:', err);
      });
  }

  function handleAddSubmit(form) {
    var btn = form.querySelector('[data-upsell-add-btn]');
    var btnText = form.querySelector('[data-upsell-btn-text]');
    var select = form.querySelector('[data-upsell-variant-select]');
    var hiddenInput = form.querySelector('input[name="id"]');
    var variantId = select ? select.value : (hiddenInput ? hiddenInput.value : null);

    if (!variantId) {
      console.error('[cart-drawer-upsell] chybi variant ID, formular:', form);
      return;
    }

    if (btn) btn.setAttribute('disabled', 'disabled');
    if (btnText) btnText.textContent = 'Wird hinzugefügt...';

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error((err && err.description) || 'Produkt konnte nicht hinzugefügt werden.');
          });
        }
        return res.json();
      })
      .then(function () {
        if (btnText) btnText.textContent = 'Hinzugefügt';
        if (btn) btn.classList.add('is-added');
        updateCartCountBubble();
        refreshCartDrawer();
      })
      .catch(function (err) {
        console.error('[cart-drawer-upsell] add selhal:', err);
        if (btnText) btnText.textContent = 'Fehler, erneut versuchen';
        if (btn) btn.removeAttribute('disabled');
        setTimeout(function () {
          if (btnText) btnText.textContent = 'Hinzufügen';
        }, 2500);
      });
  }

  // KRITICKE: capture faza - zachytime submit este pred akymkolvek inym
  // listenerom v teme, aby sa nikdy neodoslal nativny (neajaxovy) submit,
  // ktory by reloadol stranku.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target && e.target.closest && e.target.closest('[data-upsell-form]');
      if (!form) return;
      e.preventDefault();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
      handleAddSubmit(form);
    },
    true
  );

  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest && e.target.closest('[data-upsell-prev]');
    var nextBtn = e.target.closest && e.target.closest('[data-upsell-next]');
    if (!prevBtn && !nextBtn) return;
    var viewport = (prevBtn || nextBtn).closest('.cart-upsell__viewport');
    var track = viewport && viewport.querySelector('.cart-upsell__track');
    if (!track) return;
    var dir = prevBtn ? -1 : 1;
    lastManualInteraction = Date.now();
    track.scrollBy({ left: dir * cardWidth(track), behavior: 'smooth' });
  });

  document.addEventListener(
    'scroll',
    function (e) {
      var track = e.target && e.target.classList && e.target.classList.contains('cart-upsell__track') ? e.target : null;
      if (!track) return;
      lastManualInteraction = Date.now();
    },
    true
  );

  function isElementVisible(el) {
    if (!el) return false;
    var style = getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
  }

  function autoAdvanceUpsellTracks() {
    if (Date.now() - lastManualInteraction < MANUAL_PAUSE_MS) return;
    var tracks = document.querySelectorAll('.cart-upsell__track');
    tracks.forEach(function (track) {
      if (!isElementVisible(track)) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 2) return;
      if (track.scrollLeft >= maxScroll - 4) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: cardWidth(track), behavior: 'smooth' });
      }
    });
  }
  setInterval(autoAdvanceUpsellTracks, AUTOPLAY_INTERVAL_MS);

  // ---- Zavreni upsell boxu tlacitkem X (plati jen do dalsiho otevreni drawera) ----
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest && e.target.closest('[data-upsell-close]');
    if (!closeBtn) return;
    var box = closeBtn.closest('.cart-upsell');
    if (box) box.style.display = 'none';
  });

  // Kdyz se drawer znovu otevre, upsell box se vzdy znovu ukaze
  // (i kdyz byl predtim zavreny krizkem) - resetuje se pri kazdem otevreni.
  function resetUpsellVisibilityOnOpen() {
    document.querySelectorAll('.cart-upsell').forEach(function (box) {
      box.style.display = '';
    });
  }

  var lastRefresh = 0;
  function throttledRefresh() {
    var now = Date.now();
    if (now - lastRefresh < 700) return;
    lastRefresh = now;
    refreshCartDrawer();
  }

  function isVisible(el) {
    if (!el) return false;
    var style = getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
  }

  var observedContainer = null;
  function watchDrawerVisibility() {
    var container = findInDoc(document);
    if (!container || container === observedContainer) return;
    observedContainer = container;

    var wasVisible = isVisible(container);
    var mo = new MutationObserver(function () {
      var nowVisible = isVisible(container);
      if (nowVisible && !wasVisible) {
        throttledRefresh();
        resetUpsellVisibilityOnOpen();
        forceUpsellCardStyles();
      }
      wasVisible = nowVisible;
    });
    mo.observe(container, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden', 'open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawerVisibility);
  } else {
    watchDrawerVisibility();
  }
  document.addEventListener('cart:refresh', watchDrawerVisibility);

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('a[href*="/cart"], [data-cart-icon], .cart-icon, #cart-icon-bubble, [data-cart-trigger]');
    if (!trigger) return;
    resetUpsellVisibilityOnOpen();
    throttledRefresh();
    setTimeout(function () {
      throttledRefresh();
      resetUpsellVisibilityOnOpen();
    }, 350);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form || form.hasAttribute('data-upsell-form')) return;
    setTimeout(throttledRefresh, 600);
  });

  forceUpsellCardStyles();
  window.addEventListener('resize', forceUpsellCardStyles);
})();